var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indicator",class:{
    selected: _vm.val,
  },style:({
    width: (_vm.size + "px"),
    minWidth: (_vm.size + " px"),
    height: (_vm.size + "px"),
    borderWidth: ((_vm.size / 8) + "px"),
  })},[_c('div',{staticClass:"ind",style:({
      width: ((_vm.size / 2.5) + "px"),
      height: ((_vm.size / 2.5) + "px"),
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }